import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { BranchForm } from '@/modules/branches/components/BranchForm'
import { useBranchMutation } from '@/modules/branches/hooks/useBranchMutation'

export function BranchCreatePage() {
  const { create, isSubmitting, error } = useBranchMutation()

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to="/branches" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Nueva Sucursal</h1>
      </div>
      <div className="card p-6">
        <BranchForm
          onSubmit={create}
          isSubmitting={isSubmitting}
          submitLabel="Crear Sucursal"
          error={error}
        />
      </div>
    </div>
  )
}
